import { Box, Stack, Typography } from '@mui/material';

import ArrowDirectBottom from '@/ui/assets/arrow-direct-bottom.svg';
import ArrowDirectEmpty from '@/ui/assets/arrow-direct-empty.svg';
import ArrowDirectTop from '@/ui/assets/arrow-direct-top.svg';
import ArrowIncomingLeft from '@/ui/assets/arrow-incoming-left.svg';
import ArrowIncomingRight from '@/ui/assets/arrow-incoming-right.svg';
import ArrowOutcomingLeft from '@/ui/assets/arrow-outcoming-left.svg';
import ArrowOutcomingRight from '@/ui/assets/arrow-outcoming-right.svg';

export function DevOnTourArrows() {
  return (
    <>
      <img src={ArrowIncomingLeft} />
      <img src={ArrowIncomingLeft} width="28" height="28" />
      <img
        src={ArrowIncomingLeft}
        width="28"
        height="28"
        style={{ position: 'relative', top: 2, marginRight: 8 }}
      />
      <br />
      <img src={ArrowIncomingRight} />
      <img src={ArrowIncomingRight} width="10" height="10" />
      <img
        src={ArrowIncomingRight}
        width="20"
        height="20"
        style={{ position: 'relative', top: 10 }}
      />
      <br />
      <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 0.25 }}>
        <Typography>Paris</Typography>
        <img src={ArrowIncomingLeft} style={{ position: 'relative', top: 2 }} />
      </Stack>
      <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
        <Box sx={{ width: '4rem', border: '1px solid', borderRadius: 2 }}>
          CO2
        </Box>
        <img
          src={ArrowIncomingRight}
          style={{ position: 'relative', right: 4 }}
        />
      </Stack>
      <img src={ArrowOutcomingLeft} />
      <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 0.25 }}>
        <img src={ArrowOutcomingRight} />
        <Typography>Paris</Typography>
      </Stack>
      <br />
      <img src={ArrowDirectTop} />
      <img src={ArrowDirectBottom} />
      <img src={ArrowDirectEmpty} />
    </>
  );
}
